import { toast } from '@randstad-lean-mobile-factory/react-components-core';
import { useQuery } from '@tanstack/react-query';

import { GetRoutingsBody, RoutingsService } from '../../Services/API';
import { QueryKeys } from '../types';

export const useFetchRoutings = (params: GetRoutingsBody) => {
  return useQuery(
    [QueryKeys.fetchRoutings, params],
    async () => {
      return RoutingsService.routingsControllerSearchRoutings({ body: params });
    },
    {
      onError: () => {
        toast.error('Erreur lors de la récupération des routages');
      },
    }
  );
};
